// Software built by  Adeweb Developer Africa
// portfolio website: https://adeweb-developer.vercel.app
// whatsApp Message: https://wa.me/23407043455416
// I am open for your software development gig, thank you

import React from "react";
import "./OnboardingStyle.css";
import { useEffect, useState } from "react";
import NextArrow from "../../assets/facingright.svg";
import BackArrow from "../../assets/goBackarrow.svg";
import CardTwo from "../../assets/OnboardingCards/cardOne.svg";
import LoveIcon from "../../assets/OnboardingCards/Loveiconbn.svg";
import { useNavigate } from "react-router-dom";
import ChatAssistance from "../../assets/OnboardingCards/HelpLoverr.svg";
import './DesktopOnboardingStyle.css'


const OnboardingScreen2 = ({ nextStep, prevStep }) => {
  const navigate = useNavigate();

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const imageStyle = {
    width: isMobile ? "105%" : "40%",
    marginTop: isMobile ? "14%" : "20%",
    display: isMobile ? "flex" : "flex",
    marginBottom: isMobile ? "10%" : "10%",
  };

  const boxStyle = {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
    padding: 20,
    marginTop: "8rem",
    marginBottom: "8rem",
    backgroundColor: "#f5f6f7",
    alignItem: 'center'
  };


  return (
    <div className="onboarding-screen">
      <div className="onboardingBackBTN">
        <button onClick={prevStep}>
          <img src={BackArrow} alt="back button" />
        </button>
        {!isMobile && (
          <div className="authhext">
          Ikorodu dating site
        </div>
        )}

        <button onClick={() => navigate("/help")}>
          <img src={ChatAssistance} alt="back button" />
        </button>
      </div>
      <div style={!isMobile ? boxStyle : {}} className="onboardingTop">
        <img
          style={imageStyle}
          src={CardTwo}
          alt="back button"
        />

         <img
          style={imageStyle}
          src={CardTwo}
          alt="back button"
        />
        

     
      </div>
      
      <div style={{position: 'absolute', paddingBottom: '30px'}} className="onboardingBottom shortBottom">
        <img
          style={{ width: 70, marginTop: "2%", marginBottom: '3%' }}
          src={LoveIcon}
          alt="love icon"
        />

        <div style={{
          marginBottom: '15px'
        }} className="bottomHolder">
          <h1>Meet New People!</h1>
          <p>Connect with people who share your interests.</p>
          <button onClick={nextStep}>
            Next <img src={NextArrow} alt="back button" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default OnboardingScreen2;
